import { AddCircle } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { createContext, useEffect, useState } from 'react'
import { ModalAgregaCapituloComponent } from '../../components/capitulos/ModalAgregaCapituloComponent';
import { ModalEliminarCapituloComponent } from '../../components/capitulos/ModalEliminarCapituloComponent';
import { TablaCapitulos } from '../../components/capitulos/TablaCapitulos';
import { TituloComponent } from '../../components/TituloComponent';
import { ObtenerCapitulos } from '../../helpers/CapitulosHelper';

export const CapitulosContext = createContext();

export const CapitulosPage = () => {
    const [modalAgregaCapitulo, setModalAgregaCapitulo] = useState(false);
    const [modalEliminarCapitulo, setModalEliminarCapitulo] = useState(false)
    const [capituloSel, setCapituloSel] = useState();
    const [capitulos, setCapitulos] = useState();

    const obtenerCapitulos = () => {
        ObtenerCapitulos().then(response => {
            setCapitulos(response);
        })
    }

        useEffect(() => {
            obtenerCapitulos();
        }, [])
        

  return (
    <CapitulosContext.Provider value={{modalAgregaCapitulo, setModalAgregaCapitulo, capituloSel, setCapituloSel, obtenerCapitulos,
    modalEliminarCapitulo, setModalEliminarCapitulo}} >
    <div
    style={{
        marginTop:10,
        marginLeft:40
    }}
>
    <span
      style={{
          display:'flex',
          flexDirection:'row',
          alignItems:'center',
          justifyContent:'space-between',
          maxWidth:'40%'
        }}
    >
        <TituloComponent titulo='Capítulos' />
      <IconButton
        onClick={() => {setCapituloSel(); setModalAgregaCapitulo(true)}}
      >
        <AddCircle style={{color:'#60318A'}} color="#60318A" />
        Agregar
      </IconButton>
    </span>
    <div
        style={{
        fontSize:28,
        fontWeight:'regular',
        marginLeft:10,
        maxWidth:900,
        flex:1,
        backgroundColor:'transparent'
        }}
    >
        <TablaCapitulos capitulos={capitulos} />
    </div>
    <ModalAgregaCapituloComponent />
    <ModalEliminarCapituloComponent /> 
</div>
    </CapitulosContext.Provider>  
  )
}
